/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: 0,
  isLoading: false,
  isError: false,
  responseTime: 0,
  msgError: '',
};

export const headcountTurnoverVoluntaryReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case actionType.HEADCOUNT_TURNOVER_VOLUNTARY + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.HEADCOUNT_TURNOVER_VOLUNTARY + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
      };
    case actionType.HEADCOUNT_TURNOVER_VOLUNTARY + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.HEADCOUNT_TURNOVER_VOLUNTARY + '_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
        status: action.status
      }
    default:
      return state;
  }
};
